export function timeAgo(dateStr: string | null): string {
  if (!dateStr) return "";
  const d = new Date(
    dateStr.includes("Z") || dateStr.includes("+") ? dateStr : dateStr + "Z"
  );
  const now = new Date();
  const diff = (now.getTime() - d.getTime()) / 1000;
  if (diff < 0 || isNaN(diff)) return dateStr;
  if (diff < 60) return "Hace un momento";
  if (diff < 3600) {
    const m = Math.floor(diff / 60);
    return `Hace ${m} minuto${m > 1 ? "s" : ""}`;
  }
  if (diff < 86400) {
    const h = Math.floor(diff / 3600);
    return `Hace ${h} hora${h > 1 ? "s" : ""}`;
  }
  if (diff < 604800) {
    const days = Math.floor(diff / 86400);
    return `Hace ${days} dia${days > 1 ? "s" : ""}`;
  }
  return d.toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function countryFlag(code: string): string {
  if (!code || code.length !== 2) return "";
  const c = code.toUpperCase();
  return String.fromCodePoint(
    ...[...c].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65)
  );
}

export function scoreColor(score: number): string {
  if (score >= 7) return "#1A8754";
  if (score >= 5) return "#E08700";
  return "#E04040";
}

export function parseAiAnalysis(
  raw: string | Record<string, unknown> | null
): Record<string, unknown> | null {
  if (!raw) return null;
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
